<template>
  <v-layout row wrap align-end white mb-2 mt-2>
    <v-flex ml-4 xs3>
      <v-select
        class="pt-0"
        v-model="formData.condominium_id"
        :items="condominiumsList"
        item-text="name_fantasy"
        item-value="id"
        @change="getIndex"
        label="Selecione o condomínio"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>
        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-select>
    </v-flex>
    <v-flex xs3 ml-3>
      <v-select
        class="pt-0"
        v-model="formData.financial_id"
        :items="financialList"
        :disabled="!formData.condominium_id"
        item-text="name"
        item-value="id"
        label="Selecione o índice da conta"
      ></v-select>
    </v-flex>
    <v-flex xs3 ml-3>
      <v-text-field
        class="pt-0"
        v-model="formData.account_name"
        label="Procurar conta"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
const defaultForm = {
  condominium_id: '',
  account_name: '',
  financial_id: ''
}
export default {
  data () {
    return {
      formData: {},
      condominiumsList: [],
      financialList: []
    }
  },
  props: {
    searchAccounts: Function
  },
  mounted () {
    this.formData = { ...defaultForm }
    this.getComdominiums()
  },
  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },
    getComdominiums () {
      let obj = {
        url: '/api/condominium',
        query: '',
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.condominiumsList = response.data
      })
    },
    getIndex () {
      let queryParams = {}
      queryParams.params = {
        condominium_id: this.formData.condominium_id
      }

      let obj = {
        url: '/api/financial',
        query: queryParams,
        method: 'get'
      }
      this.$store.dispatch('request/doRequest', obj).then(response => {
        this.financialList = response.data
      })
    },
    search () {
      this.searchAccounts(this.formData)
    }
  }
}
</script>

<style>
</style>
